import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '@purespectrum1/ui/button';
import { AuthGuard } from '../auth/auth.guard';
import { FeatureFlagGuard } from '../auth/feature-flag.guard';
import { UserGuard } from '../auth/user.guard';
import { USER_TYPES } from '../operator/manage-companies/manage-companies-form/constant';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '../layout/layout.module';
import { TransactionsToolComponent } from './transactions-tool/transactions-tool.component';
import { BuyerSurveySimulatorComponent } from './buyer-survey-simulator/buyer-survey-simulator.component';
import { FeotPacingToolComponent } from './feot-pacing-tool/feot-pacing-tool.component';

@NgModule({
  declarations: [
    TransactionsToolComponent,
    FeotPacingToolComponent,
    BuyerSurveySimulatorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    RouterModule.forChild([
      {
        path: 'tools',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'transactions-tool',
            component: TransactionsToolComponent,
            canActivate: [FeatureFlagGuard],
            data: { flagName: 'enableTransactionTestingTool' },
          },
          {
            path: 'feot-clock-tool',
            component: FeotPacingToolComponent,
            canActivate: [UserGuard],
            data: { roles: [USER_TYPES.OPERATOR] },
          },
        ],
      },
      {
        path: 'buyer-survey-simulator',
        component: BuyerSurveySimulatorComponent,
      },
    ]),
    LayoutModule,
  ],
})
export class PsToolsModule {}
